import { render, staticRenderFns } from "./customizationList.vue?vue&type=template&id=5c4ac4b7&scoped=true&"
import script from "./customizationList.vue?vue&type=script&lang=js&"
export * from "./customizationList.vue?vue&type=script&lang=js&"
import style0 from "./customizationList.vue?vue&type=style&index=0&id=5c4ac4b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ac4b7",
  null
  
)

export default component.exports